<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-12 px-1" v-if="statusSnack.snack">
        <v-snackbar
          v-model="statusSnack.snack"
          :timeout="2000"
          :color="statusSnack.snackColor"
        >
          {{ statusSnack.snackText }}
          <v-btn text @click="resetStatusSnack()">Close</v-btn>
        </v-snackbar>
      </div> 
    </div>
    <div class="row">
      <v-expansion-panels class="advising-expanstion-panel" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header
            >Set Advising Availability</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-card>
              <v-tabs v-model="tab" background-color="primary" dark>
                <v-tab v-for="(item, day) in availability" :key="day">{{
                  day
                }}</v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item v-for="(times, day) in availability" :key="day">
                  <v-card flat>
                    <v-card-text>
                      
                      <v-row
                        v-for="(time, key) in times.timeslots"
                        :key="`${day}-${key}`"
                      >
                        <v-col col-6 sm="5">
                          <v-text-field
                            v-model="time['from']"
                            type="time"
                            label="From:"
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col col-6 sm="5">
                          <v-text-field
                            v-model="time['to']"
                            type="time"
                            label="To:"
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col col-6 sm="2" class="mt-3">
                          <v-icon
                            v-if="key != 0"
                            color="error"
                            @click="removeTimeSlot(day, key, time['id'])"
                            >mdi-delete</v-icon
                          >
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <v-card-text>
                      <v-row>
                        <v-col col-6 sm="10" class="mt-3">
                          <v-select
                            v-model="times.selectedFormats"
                            :items="appointmentFormats"
                            item-text="option"
                            item-value="value"
                            multiple
                            outlined
                            label="Appointment Format"
                          >
                          </v-select>
                        </v-col>
                        <v-col col-6 sm="2" class="mt-3"> </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions class="mt-5">
                      <v-btn color="primary" @click="insertTimeSlot(day)"
                        >Add Time Slot</v-btn
                      >
                      <v-btn color="success" @click="storeAvailability(day)"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >Add Additional Advising Details</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <p>Additional details for advising</p>
                <quill-editor
                  ref="myTextEditor"
                  v-model="advisingAdditionalDetails"
                  :options="editorOption"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @ready="onEditorReady($event)"
                >
                </quill-editor>
                <v-divider></v-divider>
                <p>Appointment scheduling information</p>
                <quill-editor
                  ref="myTextEditor"
                  v-model="appointmentSchedulingInfo"
                  :options="editorOption"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @ready="onEditorReady($event)"
                >
                </quill-editor>
              </v-card-text>
              <v-card-actions class="mt-5">
                <v-btn color="primary" @click="storeAdditionalDetails()"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >Appointment Schedule Buffer</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-select
                  v-model="scheduleBuffer"
                  :items="bufferList"
                  outlined
                  label="Appointment schedule buffer (hours)"
                >
                </v-select>
              </v-card-text>
              <v-card-actions class="mt-5">
                <v-btn color="primary" @click="storeAdditionalDetails()"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >Appointment In Between Buffer</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-select
                  v-model="scheduleInBetweenBuffer"
                  :items="inBetweenBufferList"
                  outlined
                  label="Appointment in between buffer (minutes)"
                >
                </v-select>
              </v-card-text>
              <v-card-actions class="mt-5">
                <v-btn color="primary" @click="storeAdditionalDetails()"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >Set Appointment Length</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-select
                  v-model="selectedLengths"
                  :items="appointmentLengths"
                  multiple
                  outlined
                  label="Appointment Length (minutes)"
                >
                </v-select>
              </v-card-text>
              <v-card-actions class="mt-5">
                <v-btn color="primary" @click="storeAdditionalDetails()"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >Set Formats of the Appointment</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-select
                  v-model="selectedFormats"
                  :items="appointmentFormats"
                  item-text="option"
                  item-value="value"
                  multiple
                  outlined
                  label="Appointment Format"
                >
                </v-select>
              </v-card-text>
              <v-card-actions class="mt-5">
                <v-btn color="primary" @click="storeAdditionalDetails()"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            >Set Prospective Student Access Pin</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-text-field
                  v-model="prospectiveStudentAccessPin"
                  type="text"
                  label="Access Pin"
                  outlined
                ></v-text-field>
              </v-card-text>
              <v-card-actions class="mt-5">
                <v-btn color="primary" @click="storeAdditionalDetails()"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<style>
.advising-expanstion-panel {
  border: 1px solid #ccc;
  min-height: auto;
  max-height: unset;
  overflow: auto;
  scrollbar-width: thin;
}
</style>

<script>
import { mapState } from "vuex";
export default {
  props: {
    uin: {
      type: String,
      required: true,
    },
    isAdmin: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      appname: process.env.MIX_APP_NAME,
      tab: null,
      availability: {
        monday: {
          timeslots: [{ id: null, from: 2000, to: null }],
          selectedFormats: [],
        },
        tuesday: {
          timeslots: [{ id: null, from: null, to: null }],
          selectedFormats: [],
        },
        wednesday: {
          timeslots: [{ id: null, from: null, to: null }],
          selectedFormats: [],
        },
        thursday: {
          timeslots: [{ id: null, from: null, to: null }],
          selectedFormats: [],
        },
        friday: {
          timeslots: [{ id: null, from: null, to: null }],
          selectedFormats: [],
        },
        saturday: {
          timeslots: [{ id: null, from: null, to: null }],
          selectedFormats: [],
        },
        sunday: {
          timeslots: [{ id: null, from: null, to: null }],
          selectedFormats: [],
        },
      },
      currentTerm: null,
      advisingAdditionalDetails: "",
      appointmentSchedulingInfo: "",
      scheduleBuffer: 4,
      scheduleInBetweenBuffer: 0,
      bufferList: [1, 2, 3, 4, 5, 6, 7, 8],
      inBetweenBufferList: [0, 5, 10, 15, 30, 45, 60],
      appointmentLengths: [15, 30, 45, 60],
      appointmentFormats: [
        { value: "office", option: "Advisor's Office" },
        { value: "phone", option: "Phone" },
        { value: "zoom", option: "Zoom" },
      ],
      selectedLengths: [],
      selectedFormats: [],
      prospectiveStudentAccessPin: null,
      letter: {
        subject: "",
        body: "",
        saveAndSend: false,
      },
      editorOption: {
        modules: {},
      },
    };
  },
  computed: {
    ...mapState({
      statusfromStore: (state) => state.status,
    }),
    statusSnack: {
      get() {
        return this.statusfromStore;
      },
      set(newName) {
        return newName;
      },
    },
  },
  watch: {
    selectedAdvisor: async function (val) {
      await this.getAdvisorPreference();
      await this.getAdvisorAvailability();
      await this.getAdvisorCalendar();
    },
    statusSnack: function (val) {
      this.statusSnack = val;
    },
  },
  mounted() {
    this.getAvailability();
    this.getAdivsorPreference();
  },
  methods: {
    async getAvailability() {
      await axios
        .get("/api/v1/advisoravailability/" + this.uin)
        .then((response) => {
          var days = response.data;

          if (Object.keys(days).length > 0) {
            Object.keys(days).forEach((day) => {
              
              this.availability[day].timeslots = [];
               this.availability[day].selectedFormats = days[day][0].appointment_formats ? JSON.parse(days[day][0].appointment_formats) : ["zoom"]
              days[day].forEach((time) => {
                this.availability[day].timeslots.push({
                  id: time.id,
                  from: time.from,
                  to: time.to,
                });
              });
            });
          }
        })
        .catch((error) => {});
    },
    async storeAvailability(day) {
      console.warn(this.availability)
      await axios
        .post("/api/v1/advisoravailability", {
          day: day,
          times: this.availability[day],
        })
        .then((response) => {
          console.warn(response)
          this.$store.commit("status/setStatus", {
            snack: true,
            snackColor: "success",
            snackText: "Preferences saved",
          });
        })
        .catch((error) => {});
    },
    async storeAdditionalDetails() {
      await axios
        .post("/api/v1/advisoradvisingdetails", {
          details: this.advisingAdditionalDetails,
          schedulingInfo: this.appointmentSchedulingInfo,
          scheduleBuffer: this.scheduleBuffer,
	  scheduleInBetweenBuffer: this.scheduleInBetweenBuffer,
          appointmentLengths: this.selectedLengths,
          appointmentFormats: this.selectedFormats,
          prospectiveStudentAccessPin: this.prospectiveStudentAccessPin,
        })
        .then((response) => {
          this.$store.commit("status/setStatus", {
            snack: true,
            snackColor: "success",
            snackText: "Preferences saved",
          });
        })
        .catch((error) => {});
    },
    async getAdivsorPreference() {
      await axios
        .get("/api/v1/advisorpreference/" + this.uin)
        .then((response) => {
          if (response.data) {
            this.advisingAdditionalDetails =
              response.data["advising_additional_details"];
            this.appointmentSchedulingInfo =
              response.data["scheduling_information"];
            this.scheduleBuffer = response.data["schedule_buffer"];
	    this.scheduleInBetweenBuffer = response.data["schedule_in_between_buffer"];
            this.selectedLengths = JSON.parse(
              response.data["appointment_lengths"]
            );
            
            this.prospectiveStudentAccessPin =
              response.data["prospective_student_login_pin"];
          }
        })
        .catch((error) => {});
    },
    insertTimeSlot(day) {
      this.availability[day].timeslots.push({ id: null, from: null, to: null });
    },
    async removeTimeSlot(day, pos, id) {
      if (id != null) {
        await axios
          .delete("/api/v1/advisoravailability/" + id)
          .then((response) => {
            this.$store.commit("status/setStatus", {
              snack: true,
              snackColor: "success",
              snackText: "Time slot removed",
            });
          })
          .catch((error) => {});
      }
      this.availability[day].timeslots.splice(pos, 1);
    },
    async storeAccessPin() {},
    onEditorBlur(editor) {
      // console.log('editor blur!', editor)
    },
    onEditorFocus(editor) {
      // console.log('editor focus!', editor)
    },
    onEditorReady(editor, body = null) {},
    onEditorChange({ quill, html, text }) {
      // console.log('editor change!', quill, html, text)
      this.content = html;
    },
  },
};
</script>
